import { createSlice } from "@reduxjs/toolkit";

export const initialPersonalizationState = () => {
    return {
        items: [],
        type: null,
        isLoaded: false,
    };
};

const personalizationSlice = createSlice({
    name: "personalization",
    initialState: initialPersonalizationState(),
    reducers: {
        receive: (state, action) => {
            if (action.payload.json instanceof Array) {
                return {
                    ...state,
                    items: action.payload.json,
                    type: action.payload.rectype,
                    isLoaded: true,
                };
            }
        },
        fetch_error: (state) => {
            return {
                ...state,
                isLoaded: true,
            };
        },
    },
});

export const {
    receive: receive_personalized_items,
    fetch_error: personalized_items_fetch_error,
} = personalizationSlice.actions;

export default personalizationSlice.reducer;
